import type { VariantLoadingTextProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { getSizeClass } from '../helper';
import '../index.less';

function TextShimmerLoading({ text = 'Thinking', className, size = 'md' }: VariantLoadingTextProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <div ref={ref} className={cn('wg-variant-loading__text-shimmer', getSizeClass(size), className)}>{text}</div>
  );
}

const TextShimmerLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingTextProps>(TextShimmerLoading);
TextShimmerLoadingComponent.displayName = 'TextShimmerLoading';

export default TextShimmerLoadingComponent;
